// extracted by mini-css-extract-plugin
module.exports = {"user-avatar":"NBqHZ","userAvatar":"NBqHZ","pixelated":"_1Y6U1"};